import Vue from 'vue';

// 此组件用于非继承关系的组件之间的值传递等
// 现用于Popup与画面间的值传递。
const Hub = new Vue();
export default Hub;

